import React, { useEffect, useState, Fragment } from "react";
import { useHistory, Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

import CarouselCursos from "../../components/Slick/CarouselCursos";
import CarouselVacante from "../../components/Slick/CarouselCandidato";
import CarouselEmpresa from "../../components/Slick/CarouselEmpresa";
import LinkButton from "../../utils/LinkButton";
import useMediaQuery from "../../Hooks/useMediaQuery";
import useToggle from "../../Hooks/useToggle";
import Modal from "react-bootstrap/Modal";
import FabHome from "../../components/Slide/FaqHome";
import Fabcerrar from "../../components/Slide/Fabcerrar";
import CardGroups from "../../components/Aplicant/CardGroups";
import user from "../../static/images/user_default.png";

import "../../static/css/custom.css";

function Home({ data }) {
  const [companyData, setcompanyData] = useState("");
  const [lastVacant, setlastVacant] = useState([]);

  const isMobile = useMediaQuery("(max-width: 927px)");

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [events, setEvents] = useState([]);

  const matchedMobile = useMediaQuery("(max-width: 927px)");
  const [isPanelOpen, togglePanel] = useToggle(false);

  let history = useHistory();

  useEffect(() => {
    //Validamos que el perfil este completado, de lo contrario lo redireccionamos a la pagina perfil
    const getApplicant = () => {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("tok");

      let userId = localStorage.getItem("userId");
      axios
        .get("access/company/" + userId)
        .then((result) => {
          if (result.status === 200) {
            if (!result.data.hasOwnProperty("userId")) {
              history.push("/CentroFormacion/Perfil");
            }
            setcompanyData(result.data);
            if (result.data.companyProfileId) {
              GetVacantsCompany(result.data.companyProfileId);
            }
          } else if (result.status === 400) {
            toast.error(
              result.errors[0].field + " " + result.errors[0].defaultMessage
            );
          } else toast.error(result.message);
        })
        .catch((e) => {
          if (!e.status) {
            toast.error(
              "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
              { duration: 5000 }
            );
          }
        });
    };

    const getVacantes = () => {
      axios
        .get("company-vacant/list")
        .then((result) => {
          if (result.status === 200) {
            //setvacantList(result.data);
          } else if (result.status === 400) {
            toast.error(
              result.errors[0].field + " " + result.errors[0].defaultMessage
            );
          } else toast.error(result.message);
        })
        .catch((e) => {
          if (!e.status) {
            toast.error(
              "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
              { duration: 5000 }
            );
          }
        });
    };

    const getEmpresas = () => {
      axios
        .get("access/list-company")
        .then((result) => {
          if (result.status === 200) {
            //setempresasList(result.data);
          } else if (result.status === 400) {
            toast.error(
              result.errors[0].field + " " + result.errors[0].defaultMessage
            );
          } else toast.error(result.message);
        })
        .catch((e) => {
          if (!e.status) {
            toast.error(
              "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
              { duration: 5000 }
            );
          }
        });
    };

    const getCentros = () => {
      axios
        .get("formacion/list")
        .then((result) => {
          if (result.status === 200) {
            //setcentrosList(result.data);
          } else if (result.status === 400) {
            toast.error(
              result.errors[0].field + " " + result.errors[0].defaultMessage
            );
          } else toast.error(result.message);
        })
        .catch((e) => {
          if (!e.status) {
            toast.error(
              "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
              { duration: 5000 }
            );
          }
        });
    };

    const getCursos = () => {
      axios
        .get("company-course/all-courses/")
        .then((result) => {
          if (result.status === 200) {
            //setcursos(result.data);
          } else if (result.status === 400) {
            toast.error(
              result.errors[0].field + " " + result.errors[0].defaultMessage
            );
          } else toast.error(result.message);
        })
        .catch((e) => {
          if (!e.status) {
            toast.error(
              "Problemas para conectarse al servidor, favor verifique su conexion e intentelo nuevamente",
              { duration: 5000 }
            );
          }
        });
    };

    function GetVacantsCompany(id) {
      let config = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          "Access-Control-Allow-Origin": "*",
        },
      };
      axios.get("company-vacant/list-vacants/" + id, config).then((result) => {
        if (result.data?.length > 0)
          setlastVacant(result.data[0].companyDTOResponse);
      });
    }

    getApplicant();
    //getVacantes();
    // getEmpresas();
    //getCentros();
    //getCursos();
  }, []);

  useEffect(() => {
    if (data?.userId?.userId) {
      axios
        .get(`/user/${data.userId.userId}/exclusive-events`)
        .then((result) => {
          let _new = [];

          _new = result?.data?.sort(function (a, b) {
            let date_1 = new Date(a.startDate).getTime();
            let date_2 = new Date(b.startDate).getTime();

            return date_2 - date_1;
          });

          setEvents(_new.splice(0, 10));
        });
    }
  }, [data]);

  function LoadVacants() {
    let vacantes = [];
  }

  function sinFuncionalidad() {
    setShow(true);
  }

  function sinFuncionalidadOk() {
    setShow(false);
  }

  return (
    <Fragment>
      {matchedMobile && (
        <FabHome fabAction={togglePanel} isOpen={isPanelOpen} />
      )}
      <div className="content">
        <div className="content-body row">
          <div id="left-panel" className={isPanelOpen ? "open" : ""}>
            <div className="card-container text-center">
              <div className="current-user border-purple">
                <img
                  id="headerProfilePic"
                  src={companyData.image != null ? companyData.image : user}
                  style={{
                    width: "75px",
                    height: "75px",
                    borderRadius: "6px",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                  }}
                  alt="Profile Icon"
                ></img>
              </div>
              <p className="title">{companyData.name}</p>
              {/* <p className="sub-title">{companyData.profession}</p> */}
              <hr></hr>
              <LinkButton className="btn-deg" to="/CentroFormacion/Perfil">
                Ir a mi Perfil
              </LinkButton>
              {matchedMobile && (
                <Fabcerrar fabAction={togglePanel} isOpen={isPanelOpen} />
              )}
              <hr></hr>
              <LinkButton
                to="/CentroFormacion/Formacion/Publica/Cursos"
                className="btn-flat"
              >
                Ver formaciones
              </LinkButton>
              <br></br>
              <br></br>
              <LinkButton
                to="/CentroFormacion/Vacante/EstadoVacantes"
                className="btn-flat"
              >
                Ver Empleos
              </LinkButton>
            </div>
            <div className="card-container">
              <p className="title big">Tus Eventos</p>
              <hr></hr>

              {events.map((elm, i) => {
                return (
                  <>
                    <div
                      className="img-community border-purple"
                      style={{ backgroundImage: `url(${elm.image})` }}
                    />

                    <div className="content-info-card">
                      <span className="title">{elm.name}</span>
                      <br />
                      <br />

                      <span className="sub-title">{elm.place}</span>
                      <br />
                      <Link
                        className="sub-title fw-semi-bold link-purple"
                        to={{
                          pathname: "/CentroFormacion/DetalleEvento",
                          state: elm,
                        }}
                      >
                        Ver
                      </Link>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div id="center-panel">
            <div className="card-container">
              <p className="title big pad-carousel-title">
                Adquiere nuevas habilidades e impulsa tu conocimiento
              </p>
              <br></br>
              <CarouselCursos
                id="CursosHabilidades"
                qty={matchedMobile ? 1 : 3}
              ></CarouselCursos>
            </div>
            <div className="card-container">
              <p className="title big pad-carousel-title">
                Forma parte de Grupos de intereses en común
              </p>
              <br></br>
              <CardGroups id="groups" qty={isMobile ? 1 : 3} />
            </div>

            <div className="card-container">
              <p className="title big pad-carousel-title">
                Candidatos que podrían interesarte
              </p>
              <br></br>
              <p className="fw-semi-bold sub-title big pad-carousel-title">
                Candidatos:
              </p>
              <CarouselVacante id="" qty="3"></CarouselVacante>
              <br></br>
              <br></br>
              <p className="fw-semi-bold sub-title big pad-carousel-title">
                <strong>Pasantes:</strong>
              </p>
              <CarouselVacante id="pasante" qty="3"></CarouselVacante>
            </div>
            <div className="card-container">
              <p className="title big pad-carousel-title">
                Conoce nuestros Aliados
              </p>
              <br></br>
              <p className="fw-semi-bold sub-title big pad-carousel-title">
                Empresas:
              </p>
              <CarouselEmpresa id="Empresas" qty="3"></CarouselEmpresa>
            </div>
          </div>
          <div id="right-panel">
            <div className="card-container" id="containervacante">
              <p className="title big">Estado de tus Vacantes</p>
              <br></br>
              {lastVacant?.length === 0 ? (
                <div>
                  <span className="title">
                    Todavía no tiene vacantes publicadas
                  </span>
                </div>
              ) : (
                <div>
                  <div className="img-community border-gray">
                    <img
                      src={
                        lastVacant?.fotoPerfilEmpresa
                          ? lastVacant?.fotoPerfilEmpresa
                          : user
                      }
                      alt="aplicantes"
                      style={{
                        width: "62px",
                        height: "62px",
                        borderRadius: "9px",
                      }}
                    ></img>
                  </div>
                  <div className="content-info-card">
                    <span className="title">{lastVacant?.cargo}</span>
                    <br></br>
                    <span className="sub-title">{lastVacant?.name}</span>
                  </div>
                </div>
              )}
              <hr></hr>
              <div className="text-center">
                <Link
                  className="sub-title fw-semi-bold link-purple"
                  to="/CentroFormacion/Vacante/EstadoVacantes"
                >
                  Ver tus publicaciones
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={show}
        keyboard={false}
        onHide={handleClose}
        dialogClassName="kr-modal"
      >
        <Modal.Body>
          <div className="form form--white ">
            <div className="div__wrapper">
              <div className="form__row">
                <div className="col-sm-12 ">
                  <label htmlFor="names">Funcionalidad en construcción</label>
                </div>
              </div>
              <div className="form__row">
                <button
                  className="btn btn--gradient btn__icon btn__icon--door"
                  onClick={() => sinFuncionalidadOk()}
                >
                  Aceptar
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}
export default Home;
